/**
 * @hidden
 */
var noop = function noop() {};

export { noop };